<template>
    <div class="flex justify-center items-center">
        <div class="w-full max-w-sm px-2">

            <h1 class="text-center text-azuloscuro text-xl font-semibold mt-10 mb-5">
                El Test
            </h1>

            <div class="w-full mb-10 self-center px-8">
                <img src="@/assets/images/Onboarding3.png"
                class="w-full mb-10 self-center" />
            </div>

            <div>
                <p class="text-center text-azuloscuro text-md mx-8">
                    En algunas Pills tendrás que realizar un pequeño test. ¡Ánimo, tú puedes!
                </p>

                <p class="text-center text-azuloscuro text-md mx-8">
                    Pulsa siempre "Terminar" para completar tu Pill.
                </p>
            </div>
            <div class="text-center mt-5" style="margin-bottom: 132px">
                <span class="ball"></span><span class="ball"></span><span class="ball filled"></span>
            </div>

            <div class="fixed inset-x bottom-0 left-0 px-4 pb-12 w-full bg-white">
                <div class="mt-5">
                    <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                            @click="finish"
                    type="button">
                        Entendido
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import Utilities from '@/plugins/Utilities.js'
    import setTitle from "../plugins/title";

    const TutorialStep3 = {
        name: 'TutorialStep3',
        layout: '',
        data: function(){
            return {

            }
        },
        beforeMount: function(){
            if(!Utilities.isLogged()){
                this.$router.push({ name:'login' })
            }
        },
        methods: {
            finish () {
                localStorage.setItem('has_completed_tutorial', true)
                this.$router.push({ name: 'home' })
            }

        },
        created () {
            setTitle('Tutorial 3/3')
        }
    }

    export default TutorialStep3;
</script>

<style>
    .ball {
        display: inline-block;
        background: gray;
        border-radius: 50%;
        width: 8px;
        height: 8px;
        margin: 0 6px;
        background: #E9ECFF;
    }

    .filled {
        background: #170E47;
    }
</style>
